import styled from '@emotion/styled';

const IconWrapper = styled('div')(
  {
    width: 38,
    height: 38,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.colors.white
  })
);

export default IconWrapper;
